import React from 'react';
import { FormattedMessage } from 'react-intl';

import { EcpStoreType } from '../../../../../rest/ecp-locator';
import {
  ShopTypeFilters,
  SpecializationTypeFilters,
} from '../../../../../graphql/ecp-locator/models/filter-params.models';
import { ToggleButtonOptions } from '../../../../common/toggle-button-group';

export const serviceTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage id="ecp.filters.modal.serviceType.items.checkPickUpLenses.label" />
  ),
  value: EcpStoreType.fitter,
}, {
  children: (
    <FormattedMessage id="ecp.filters.modal.serviceType.items.buyLenses.label" />
  ),
  value: EcpStoreType.retailer,
}];

export const serviceTypeFilteringItemsC2C: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.serviceType.items.checkPickUpLenses.label"
    />
  ),
  value: EcpStoreType.fitter,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.serviceType.items.buyLenses.label"
    />
  ),
  value: EcpStoreType.retailer,
}, {
  children: (
    <FormattedMessage
      id="order.create.button.label"
    />
  ),
  value: EcpStoreType.c2cActivated,
}];

export const specializationTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage id="ecp.filters.modal.specializationType.items.astigmatism" />
  ),
  value: SpecializationTypeFilters.astigmatism,
  tooltip: <FormattedMessage id="ecp.spec.additional.astigmatism.tooltip" />,
}, {
  children: <FormattedMessage id="ecp.spec.additional.presbyopia" />,
  value: SpecializationTypeFilters.presbyopia,
  tooltip: <FormattedMessage id="ecp.spec.additional.presbyopia.tooltip" />,
}];

export const specFilterItemsWithMyopia: ToggleButtonOptions[] = [
  ...specializationTypeFilteringItems,
  {
    children: (
      <FormattedMessage id="ecp.spec.additional.myopia_control" />
    ),
    value: SpecializationTypeFilters.myopiaControl,
    tooltip: <FormattedMessage id="ecp.spec.additional.myopia.tooltip" />,
  },
];

export const shopTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.optics"
    />
  ),
  value: ShopTypeFilters.optics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.clinics"
    />
  ),
  value: ShopTypeFilters.clinics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.vendings"
    />
  ),
  value: ShopTypeFilters.vendings,
}];
